import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@redux/hooks";
import { teacherRetrieveUnpaidLessons } from "../../../read/application/use-cases/teacher/unpaid-lessons-retrieval/retrieve-unpaid-lessons";
import { selectTeacherUnpaidLessonsRetrieval } from "@invoicing-context/read/application/use-cases/teacher/unpaid-lessons-retrieval/selectors/unpaid-lessons-selectors";
import { UnpaidLessonsDialog } from "./unpaid-lessons-dialog";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const UnpaidLessonsDialogContainer = ({ open, onOpenChange }: Props) => {
  const dispatch = useAppDispatch();
  const { data: unpaidLessons, fetching } = useAppSelector(selectTeacherUnpaidLessonsRetrieval);

  useEffect(() => {
    if (open) {
      dispatch(teacherRetrieveUnpaidLessons());
    }
  }, [dispatch, open]);

  return <UnpaidLessonsDialog open={open} onOpenChange={onOpenChange} unpaidLessons={unpaidLessons} fetching={fetching} />;
};
